import { render, staticRenderFns } from "./BoxRentalAndPre_Component.vue?vue&type=template&id=84be99c2&scoped=true&"
import script from "./BoxRentalAndPre_Component.vue?vue&type=script&lang=js&"
export * from "./BoxRentalAndPre_Component.vue?vue&type=script&lang=js&"
import style0 from "./BoxRentalAndPre_Component.vue?vue&type=style&index=0&id=84be99c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be99c2",
  null
  
)

export default component.exports